export default {
    SportTypes: {
        Running: 'running',
        Cycling: 'cycling',
        Other: 'other',
        Swimming: 'swimming',
        Strength_Training: 'strength_training',
        Cardio: 'cardio_training',
        Yoga: 'yoga',
        Pilates: 'pilates',
        Hiit: 'hiit',
        Multisport: 'multi_sport',
        Mobility: 'mobility'
    },
    HiitSubSportTypes: {
        TABATA: 'TABATA',
        EMOM: 'EMOM',
        AMRAP: 'AMRAP',
        GENERIC: 'GENERIC'
    },
    StepTypes: {
        Warm_Up: 'warmup',
        Interval: 'interval',
        Cool_Down: 'cooldown',
        Recovery: 'recovery',
        Rest: 'rest',
        Repeat: 'repeat',
        Other: 'other',
        Main: 'main'
    },
    TargetTypes: {
        No_Target: 'no.target',
        Cadence: 'cadence',
        Heart_Rate_Zone: 'heart.rate.zone',
        Pace_Zone: 'pace.zone',
        CSS_Based_Target_Pace: 'swim.css.offset',
        Power_Zone: 'power.zone',
        Speed_Zone: 'speed.zone',
        Power_Curve: 'power.curve',
        Effort_Based: 'swim.instruction'
    },
    ChildTargetTypes: {
        Select_Heart_Rate_Zone: 'select.heart.rate.zone',
        Select_Power_Zone: 'select.power.zone'
    },
    ConditionTypes: {
        Calories: 'calories',
        Distance: 'distance',
        Heart_Rate: 'heart.rate',
        Lap_Button: 'lap.button',
        Iterations: 'iterations',
        Power: 'power',
        Time: 'time',
        Fixed_Rest: 'fixed.rest',
        Fixed_Repetition: 'fixed.repetition', // send-off time
        Repitition_Time_CSS: 'repetition.swim.css.offset',
        Reps: 'reps'
    },
    IntensityTypes: {
        Active: 'active',
        Rest: 'rest',
        Warm_Up: 'warmup',
        Cool_Down: 'cooldown'
    },
    DurationTypes: {
        No_Duration: 'no.duration',
        Calories: 'calories',
        Distance: 'distance',
        Lap_Button: 'lap.button',
        Time: 'time',
        Heart_Zone: 'heart.rate',
        Power_Zone: 'power',
        Fixed_Rest: 'fixed.rest',
        Fixed_Repetition: 'fixed.repetition',
        Reps: 'reps'
    },
    StrokeTypes: {
        Any: 'any_stroke',
        Backstroke: 'backstroke',
        Breaststroke: 'breaststroke',
        Drill: 'drill', // drill was moved from strokeType to drillType, if old workout with strokeType=drill show drillType as 'drill' and update strokeType to 'choice'
        Fly: 'fly',
        Free: 'free',
        IM: 'individual_medley',
        Mixed: 'mixed'
    },
    EquipmentTypes: {
        No_Equipment: 'no.equipment',
        Fins: 'fins',
        Kickboard: 'kickboard',
        Paddles: 'paddles',
        Pull_Buoy: 'pull_buoy',
        Snorkel: 'snorkel'
    },
    BenchmarkScalingTypes: {
        Not_Set: 'not_set',
        Manual: 'manual',
        Benchmark_Scaled: 'benchmark_scaled'
    },
    RepeatTypes: {
        Iterations: 'repeat-iterations',
        Time: 'repeat-time'
    },
    WorkoutTypes: {
        TIME_ESTIMATED: 'TIME_ESTIMATED',
        DISTANCE_ESTIMATED: 'DISTANCE_ESTIMATED',
        TIME_AND_DISTANCE_ESTIMATED: 'TIME_AND_DISTANCE_ESTIMATED'
    }
};
